
import React, { useState } from 'react';
import { Camera, Book, Heart, Play, Pause, Video, Mic, Upload, Users, Home, Settings, Star, Cloud, Moon, Sun, ChevronRight, Plus, Check, X, Mail, Lock, User, ArrowRight } from 'lucide-react';
import { Card } from './Card';

export const StatCard = ({ value, label, color = '#9333ea' }) => {
  return (
    <Card>
      <div style={{ fontSize: '2.25rem', fontWeight: 'bold', color, marginBottom: '0.5rem' }}>{value}</div>
      <div style={{ color: '#4b5563', fontSize: '0.875rem' }}>{label}</div>
    </Card>
  );
};

// BookCard Component
